<template>
  <div>
    <div class="row justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div v-if="percentLoading != 0" class="progress">
      <div class="progress-bar"
           role="progressbar"
           :style="`width: ${percentLoading}%;`"
           :aria-valuenow="percentLoading" aria-valuemin="0"
           aria-valuemax="100">{{ percentLoading }}%
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'BaseComponentLoader',

  /** mixins **/
  mixins: [],

  /** props **/
  props: {
    loading: {
      type: Boolean,
      default: false,
    },

    percentLoading: {
      type: Number,
      default: 0,
    },
  },

  /** data **/
  data() {
    return {};
  },

  /** methods**/
  methods: {},

  /**  computed  **/
  computed: {},

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
  },

};
</script>

<style scoped>

</style>
